package com.appcreator.blueprint.actions

import com.appcreator.blueprint.core.Action
import com.appcreator.blueprint.core.ActionClass
import com.appcreator.blueprint.core.InputProperty
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
@SerialName("Delay")
@ActionClass(
    group = "Logic",
    title = "Delay Action",
    availableFrom = "0.0.1"
)
class DelayAction(
    @InputProperty(
        title = "Delay Duration in milliseconds",
        allowDataFields = true,
        availableFrom = "0.0.1"
    )
    val duration: String?,
): Action
